
















































































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import StyleUsageModal from "@/components/styles/modals/StyleUsageModal.vue";
import StyleDeleteModal from "@/components/styles/modals/StyleDeleteModal.vue";
import StyleCopyModal from "@/components/styles/modals/StyleCopyModal.vue";
import vSelect from "vue-select";
// service methods
import { getFilteredStyles } from "@/services/styles/stylesService";
// types
import { Style } from "@/services/styles/types";
import { stylesFields } from "@/components/styles/fields/stylesFields";
import { Option, PostTypeDropdownOptions } from "@/services/common/types";
import i18n from "@/i18n";
import { GetLocalizedStyleableTypes } from "../posts/PostTypeRegister";

@Component({
    components: { StyleDeleteModal, StyleUsageModal, vSelect, StyleCopyModal }
})
export default class Styles extends Vue {
    // local state
    styles: Style[] = [];
    fields = stylesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    itemTypes = [] as Array<PostTypeDropdownOptions>;
    searchQuery = "";
    selectedItemType = null as Option | any;
    filterCode = "";

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });

        this.itemTypes = GetLocalizedStyleableTypes();
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed
    get filteredData() {
        return this.styles.filter(
            x => (this.searchQuery === "" ? true : x.name.toLowerCase().includes(this.searchQuery.toLowerCase())) &&
                (this.filterCode === "" ? true : JSON.stringify(x.css).toLowerCase().includes(this.filterCode.toLowerCase())));
    }

    // actions
    styleUpdateRoute(styleId: string) {
        return {
            name: "updatestyle",
            params: { styleId: styleId }
        };
    }

    styleUsage(styleId: string) {
        (this.$refs.styleUsageModal as any).open(styleId);
    }

    deleteStyle(styleId: string, name: string) {
        (this.$refs.styleDeleteModal as any).open(styleId, name);
    }

    copyStyle(id: string, name: string) {
        (this.$refs.styleCopyModal as any).open(id, name);
    }

    // methods
    clearFilter() {
        this.filterCode = "";
        this.selectedItemType = null;
        this.loadStyles();
    }

    loadStyles() {
        getFilteredStyles(this.selectedItemType ? this.selectedItemType.value : "").then((response: any) => {
            this.styles = response;
            this.isBusy = false;
        });
    }

    fetchData() {
        this.isBusy = true;
        this.loadStyles();
    }
}
